import React from "react";
import { ServiceResultItem } from "../../utilities/types/clients/types";

interface MobileServiceResultCardProps {
  service: ServiceResultItem;
  onClick: () => void;
}

const MobileServiceResultCard: React.FC<MobileServiceResultCardProps> = ({ service, onClick }) => {
  return (
    <div className="flex flex-col items-center px-4 text-center *:w-full *:py-6 *:border-b *:border-b-gorgonzola-blue-100 text-closed-shutter-300" onClick={onClick}>
      <span className="font-medium line-clamp-1">{service.service_name}</span>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-xs text-closed-shutter-300/70">Status</p>
          <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${service.status === "success" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
            {service.status}
          </span>
        </div>

        <div>
          <p className="text-xs text-closed-shutter-300/70">Date</p>
          <p className="text-sm">{new Date(service.created_at * 1000).toLocaleDateString()}</p>
        </div>
      </div>

      <div>
        <p className="text-xs text-closed-shutter-300/70">Message</p>
        <p className="text-sm line-clamp-2">{service.message}</p>
      </div>
    </div>
  );
};

export default MobileServiceResultCard;
